module.exports = __webpack_public_path__ + "img/about-company-1.b5eb1030.png";